import React, {useState, useEffect,} from 'react';
import Api from '../../Api';
import Butao from '../../Components/Butao_list';
import Campo from '../../Components/Campo';
import Header from '../../Components/Header';
import { Spinner  } from "react-awesome-spinners";
import FinderSelect from 'react-finderselect';
import { Web } from '@material-ui/icons';
import Select from 'react-select';

export default ({ListEsp, setUsuariosContServ, UsuariosContServ,  Dados, Avisando, Fechar, Id, setAlert, setAlertTipo}) => {

const [Titulo, setTitulo] = useState("Vizualizar Clientes");
const [MsgErro, setMsgErro] = useState("");
const [Loading, setLoading] = useState(false);
const [Img2, setImg2] = useState("../assets/avatarimg.png");
const [Imgs2, setImgs2] = useState("");
const [Imgs1Res, setImgs1Res] = useState("");
const [Nome, setNome] = useState("");
const [Telefone, setTelefone] = useState("");
const [Mensalidade, setMensalidade] = useState("0000");
const [DiaMes, setDiaMes] = useState("00");
const [DiaMesExt, setDiaMesExt] = useState("00");
const [AtualAno, setAtualAno] = useState("0000"); 
const [QuantApp, setQuantApp] = useState("0000");
const [ValorApp, setValorApp] = useState("0000");
const [End, setEnd] = useState("");
const [Num, setNum] = useState("");
const [Bairro, setBairro] = useState("");
const [Cidade, setCidade] = useState("");
const [Estado, setEstado] = useState("");
const [NomeEmp, setNomeEmp] = useState("");
const [NomeApp, setNomeApp] = useState("");
const [AppLimit, setAppLimit] = useState("");
const [TokenMP, setTokenMP] = useState("");
const [KeyMP, setKeyMP] = useState("");
const [WebHookMP, setWebHookMP] = useState("");
const [ReceberMP, setReceberMP] = useState(true);
const [TempAti, setTempAti] = useState(0);
const [Porcen, setPorcen] = useState(0);
const [ListRepres, setListRepres] = useState([]);
const [ListRespTel, setListRespTel] = useState([]);
const [IdRepr, setIdRepr] = useState("");
const [NomeRepr, setNomeRepr] = useState("");
const [SiteApp, setSiteApp] = useState("");
const [Versao, setVersao] = useState("1.0.0");
const [MedidasAtiv, setMedidasAtiv] = useState(true);
const [AcademiaAtiv, setAcademiaAtiv] = useState(true);
const [WhatsAppAtiv, setWhatsAppAtiv] = useState(false);
const [TokenWhats, setTokenWhats] = useState("");
const [InstanciaWhats, setInstanciaWhats] = useState("");

useEffect(() => {
       ListRepresentante();     
      }, [])
useEffect(() => {
       NomeRepresentante();     
      }, [ListRepres, IdRepr])
useEffect(() => {
         PreencherFormulario() 
         console.log(ListEsp)    
        }, [ListEsp])

         const ListRepresentante = async ()=>{
          await Api.TAListRepresentantesSelect(Dados, setListRepres, setListRespTel)
        }

      const NomeRepresentante = async ()=>{
           for(let i in ListRepres){
       
        if(ListRepres[i].value === IdRepr){
          setNomeRepr(ListRepres[i].label)
          }
      
          }
        }
         const handleToggle4 = () => {
    setMedidasAtiv(!MedidasAtiv);
  };

const PreencherFormulario = () => {
      setImg2(ListEsp.Logo !== ""? ListEsp.Logo : "../assets/avatarimg.png" );
      setImgs2(ListEsp.Logo);
      setImgs1Res(ListEsp.Logo);
      setNome(ListEsp.Nome);
      setTelefone(ListEsp.Telefone);
      setMensalidade(ListEsp.Mensalidade);
      setDiaMes(ListEsp.DiaMes);
      setDiaMesExt(ListEsp.DiaMes)
      setAtualAno(ListEsp.AtualAno); 
      setQuantApp(ListEsp.QuantApp);
      setValorApp(ListEsp.ValorApp);
      setEnd(ListEsp.End);
      setNum(ListEsp.Num);
      setBairro(ListEsp.Bairro);
      setCidade(ListEsp.Cidade);
      setEstado(ListEsp.Estado);
      setNomeEmp(ListEsp.NomeEmp);
      setNomeApp(ListEsp.NomeApp);
      setAppLimit(ListEsp.AppLimit);
      setTokenMP(ListEsp.TokenMP);
      setKeyMP(ListEsp.KeyMP);
      setWebHookMP(ListEsp.WebHookMP);
      setReceberMP(ListEsp.ReceberMP);
      setTempAti(ListEsp.TempLimitAtiv);
      setIdRepr(ListEsp.IdRepresentante);
      setSiteApp(ListEsp.SiteApp)
      setVersao(ListEsp.Versao)
      setMedidasAtiv(ListEsp.MedidasAtiv)
      setAcademiaAtiv(ListEsp.AcademiaAtiv)
      setWhatsAppAtiv(ListEsp.WhatsAppAtiv);
      setTokenWhats(ListEsp.TokenWhats);
      setInstanciaWhats(ListEsp.InstanciaWhats);
  } 
  const handleToggle9 = () => {
    setWhatsAppAtiv(!WhatsAppAtiv);
  }; 
  
 const handleToggle1 = () => {
    setAppLimit(!AppLimit);
  };
   const handleToggle2 = () => {
    setReceberMP(!ReceberMP);
  };
const handleToggle5 = () => {
    setAcademiaAtiv(!AcademiaAtiv);
  };

  const criando = ()=>{

    var TAAtualAno = parseInt(AtualAno)
    var TAMensalidade = parseInt(Mensalidade)
    var TADiaMes = parseInt(DiaMes)
    var TAQuantApp = parseInt(QuantApp)
    var TAValorApp = parseInt(ValorApp)


    

    if(TAValorApp >= 0){
    if(TAQuantApp >= 0){
    if(TADiaMes > 0 && TADiaMes < 27 ){
    if(TAMensalidade >= 0){
    if(TAAtualAno >= 0){
    if(Nome !=="" && Nome !==" " && Nome !=="  " && Nome !=="   " && Nome !=="    " && Nome !=="     " && Nome !=="      "
    && Nome !=="       " && Nome !=="        " && Nome !=="         " && Nome !=="          " 
    && Nome !=="           " ){
      if (navigator.onLine) {
        setMsgErro("")
        setLoading(true) 
          
       Api.TAEditarClientes(InstanciaWhats, TokenWhats, WhatsAppAtiv, AcademiaAtiv, ListEsp, MedidasAtiv, Versao, SiteApp, IdRepr, Id, Dados, Imgs1Res, TempAti, DiaMesExt, ReceberMP, Nome, AppLimit, Imgs2, TokenMP, Telefone, KeyMP, WebHookMP, Mensalidade, DiaMes, AtualAno, QuantApp, ValorApp, NomeApp, NomeEmp, Estado, Cidade, Bairro, Num, End, UsuariosContServ, setUsuariosContServ,  setMsgErro, setLoading, setAlertTipo, setAlert);
 
      } else {
        setAlert("Sem Internet");
        setAlertTipo("danger");
      }
    } else {
        setMsgErro("Preencha o Nome Completo do Cliente.")
    }
    } else {
        setMsgErro("Atualização por ano só pode Número.")
    }
    } else {
        setMsgErro("Valor Mensalidade só pode Número.")
    }
    } else {
        setMsgErro("Dia do Mês não é valido.")
    }
    } else {
        setMsgErro("Quantidade de App Free só pode Número.")
    }
    } else {
        setMsgErro("Valor de App só pode Número.")
    }
  }

  const CriandoExercicio = ()=>{

      if (navigator.onLine) {
        setMsgErro("")
         
       Api.TACriarExercicioClientes(Id, setPorcen );
 
      } else {
        setAlert("Sem Internet");
        setAlertTipo("danger");
      }
    
  }
  const DownloadImg = ()=>{


    
      if (navigator.onLine) {
        setMsgErro("")
        setLoading(true) 
          
       Api.TADownloadImg(Imgs2, setMsgErro, setLoading, setAlertTipo, setAlert  );
 
      } else {
        setAlert("Sem Internet");
        setAlertTipo("danger");
      }
    
  }

const AtualizandoTelefone = ()=>{



    

    
      if (navigator.onLine) {
        setMsgErro("")
        setLoading(true) 
          
       Api.TAEditarTelClientes(Id, Telefone,  UsuariosContServ, setUsuariosContServ, setMsgErro, setLoading, setAlertTipo, setAlert  );
 
      } else {
        setAlert("Sem Internet");
        setAlertTipo("danger");
      }
    
  }
  const ColocarImg2 = (e)=>{
    const reader = new FileReader()
    reader.onload = () => {
      if(reader.readyState === 2) {
        setImg2(reader.result);
      }
    }
   reader.readAsDataURL(e.target.files[0]);
    setImgs2(e.target.files[0]);
  }
  const ExcImg2 = ()=>{
   
    setImgs2("");
    setImg2("../assets/avatarimg.png");
  }
   const printValue1 = (target) => {
       setIdRepr(target.value)
       setNomeRepr(target.label)
        }
 

        return (
            <>
<div className="content-wrapper">
                <Header 
                Titulo={Titulo}
                Avisando={Avisando}
                Fechar={Fechar}
                />
               <section className="content">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-12">
            
              <div className="invoice p-3 mb-3">
              {/* title row */}
              <div className="row">
                <div className="col-12">
                  <h4>
                    <i className="far fa-address-card" /> Cliente 
                  </h4>
                </div>
                {/* /.col */}
              </div>
              {/* info row */}
              <div className="row invoice-info">
                <div className="col-sm-4 invoice-col">
                  <address>
                    {Loading  ?
                    <>
                      <Spinner 
                      size={64}
                      color={"#5d0bf7"}
                      sizeUnit={'px'} 
                      /><br />
                      </>
                      :
                      <>
                    <div className="col-12">
                        <Butao 
                        style={"btn .btn-sm btn-info"}
                        titulo={"Atualizar"}
                        onClick={()=>criando()}
                        />  
                    </div><br />
                    <div className="col-12">
                        <Butao 
                        style={"btn .btn-sm btn-info"}
                        titulo={"Atualizar o Telefone"}
                        onClick={()=>AtualizandoTelefone()}
                        />  
                    </div><br />
                     {MsgErro !== "" &&
                    <>
                    <div class="alert alert-danger alert-dismissible">
                  
                  <h5><i class="icon fas fa-ban"></i> Alert!</h5>
                  {MsgErro}
                </div>
                   
                    </>
                    }
                    </>
                    }
                    
                   <strong>Próximo Pagamento</strong><br />
                   <strong>Dia do Vencimento:</strong><br />
                    <string>{new Date(ListEsp.TempLimitAtiv).toLocaleDateString('pt-BR')}</string><br />
                    {ListEsp.TempLimitAtiv < new Date().getTime() &&
                    <>
                     <string style={{color:"red"}}>Vencido</string>
                          <br />
                    </>
                    }
                   
                           <br />
                     <strong>Id da Conta:</strong><br />
                    <string>{Id}</string>
                          <br />
                           <br />
                     <div style={{ textAlign: "center",  }}>
                        <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                          <div
                            onClick={handleToggle5}
                            style={{
                              width: "60px",
                              height: "30px",
                              background: AcademiaAtiv ? "linear-gradient(90deg, #00c853, #69f0ae)" : "#ccc",
                              borderRadius: "30px",
                              position: "relative",
                              transition: "0.3s"
                            }}
                          >
                            <div
                              style={{
                                width: "26px",
                                height: "26px",
                                background: "#fff",
                                borderRadius: "50%",
                                position: "absolute",
                                top: "2px",
                                left: AcademiaAtiv ? "32px" : "2px",
                                transition: "0.3s",
                                boxShadow: "0 2px 5px rgba(0,0,0,0.3)"
                              }}
                            ></div>
                          </div>
                          <span style={{ marginLeft: "12px", fontSize: "15px", fontWeight: "bold" }}>
                            {AcademiaAtiv ? "Academia" : "Personal Trainer"}
                          </span>
                        </label>
                      </div>  
                    <strong>Nome do Cliente</strong><br />
                    <div className="input_cadatro">
                             
                      
                      <input
                              type="text"
                              value={Nome}
                              onChange={t=>setNome(t.target.value)}
                              className="border p-2 rounded"
                              placeholder="Digite o Nome do Cliente"
                             
                            />
                            </div> 
                    <br />
                    <strong>Nome da Empresa</strong><br />
                    <div className="input_cadatro">
                              
                              <input
                              type="text"
                              value={NomeEmp}
                              onChange={t=>setNomeEmp(t.target.value)}
                              className="border p-2 rounded"
                              placeholder="Digite a Empresa"
                            />

                            </div> 
                    <br /> 
                     <strong>Endereço</strong><br />
                    <div className="input_cadatro">
                              
                              <input
                              type="text"
                              value={End}
                              onChange={t=>setEnd(t.target.value)}
                              className="border p-2 rounded"
                              placeholder="Digite o Endereço"
                            />

                            </div> 
                    <br />   
                     <strong>Numero</strong><br />
                    <div className="input_cadatro">
                              
                              <input
                              type="text"
                              value={Num}
                              onChange={t=>setNum(t.target.value)}
                              className="border p-2 rounded"
                              placeholder="Digite o Numero"
                            />

                            </div> 
                    <br />   
                      <strong>Bairro</strong><br />
                    <div className="input_cadatro">
                              
                              <input
                              type="text"
                              value={Bairro}
                              onChange={t=>setBairro(t.target.value)}
                              className="border p-2 rounded"
                              placeholder="Digite o Bairro"
                            />

                            </div> 
                    <br />   
                  <strong>Cidade</strong><br />
                    <div className="input_cadatro">
                              
                              <input
                              type="text"
                              value={Cidade}
                              onChange={t=>setCidade(t.target.value)}
                              className="border p-2 rounded"
                              placeholder="Digite a Cidade"
                            />

                            </div> 
                    <br /> 
                    <strong>Estado</strong><br />
                    <div className="input_cadatro">
                              
                              <input
                              type="text"
                              value={Estado}
                              onChange={t=>setEstado(t.target.value)}
                              className="border p-2 rounded"
                              placeholder="Digite a Estado"
                            />

                            </div> 
                    <br />   
                   
                       {/* <strong>Contas</strong><br />
                    {ListContas.length !== 0 &&
                     <div className="input_cadatro">
                         
                      <FinderSelect 
                      data={ListContas} 
                      label='select'
                      value = 'select'  
                      extraInfo='capital' 
                      name='country' 
                      className='anyClass' 
                      placeholder='Selecione a Conta'
                      onClick={() => console.log('entering')} 
                      onChange={(target) => printValue1(target)}

                  />
                    </div> 
                    }
                    */}
                  
                 
                     
                  </address>
                    </div>
                      <div className="col-sm-4 invoice-col">
                    <address>
                   
                   <strong>Telefone do Cliente</strong><br />
                    <div className="input_cadatro">
                              
                              <Campo 
                                type={"tel"}
                                placeholder={"Digite Whatsapp"}
                                icon={"fas fa-phone"}
                                value={Telefone}
                                onChange={e=>setTelefone(e.target.value)}
                                mask={"(99)99999-9999"}
                                />

                            </div> 
                    <br />
                    
                    <strong>Nome do App</strong><br />
                    <div className="input_cadatro">
                              
                              <input
                              type="text"
                              value={NomeApp}
                              onChange={t=>setNomeApp(t.target.value)}
                              className="border p-2 rounded"
                              placeholder="Digite a Estado"
                            />

                            </div> 
                    <br /> 
                     <div style={{ textAlign: "center",  }}>
                        <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                          <div
                            onClick={handleToggle4}
                            style={{
                              width: "60px",
                              height: "30px",
                              background: MedidasAtiv ? "linear-gradient(90deg, #00c853, #69f0ae)" : "#ccc",
                              borderRadius: "30px",
                              position: "relative",
                              transition: "0.3s"
                            }}
                          >
                            <div
                              style={{
                                width: "26px",
                                height: "26px",
                                background: "#fff",
                                borderRadius: "50%",
                                position: "absolute",
                                top: "2px",
                                left: MedidasAtiv ? "32px" : "2px",
                                transition: "0.3s",
                                boxShadow: "0 2px 5px rgba(0,0,0,0.3)"
                              }}
                            ></div>
                          </div>
                          <span style={{ marginLeft: "12px", fontSize: "15px", fontWeight: "bold" }}>
                            {MedidasAtiv ? "Medidas Ativo" : "Medidas Desativado"}
                          </span>
                        </label>
                      </div>  
                     <strong>Site APP</strong><br />
                    <div className="input_cadatro">
                              
                              <input
                              type="text"
                              value={SiteApp}
                              onChange={t=>setSiteApp(t.target.value)}
                              className="border p-2 rounded"
                              placeholder="Digite o Site App"
                            />

                            </div> 
                    <br /> 
                      <strong>Versão do APP</strong><br />
                    <div className="input_cadatro">
                              
                              <input
                              type="text"
                              value={Versao}
                              onChange={t=>setVersao(t.target.value)}
                              maxLength={5}
                              className="border p-2 rounded"
                              placeholder="0.0.0"
                              size={5}
                            />

                            </div> 
                    <br />     
                    <strong>Atualização Por Ano</strong><br />
                    <div className="input_cadatro">
                              
                              <input
                              type="text"
                              value={AtualAno}
                              onChange={t=>setAtualAno(t.target.value)}
                              maxLength={4}
                              className="border p-2 rounded"
                              placeholder="0000"
                              size={4}
                            />

                            </div> 
                    <br />
                   
                     <strong>Dia do Mês</strong><br />
                    <div className="input_cadatro">
                              
                              <input
                              type="text"
                              value={DiaMes}
                              onChange={t=>setDiaMes(t.target.value)}
                              maxLength={2}
                              className="border p-2 rounded"
                              placeholder="00"
                              size={4}
                            />

                            </div> 
                    <br />
                     <strong>Valor Mensalidade</strong><br />
                    <div className="input_cadatro">
                              
                              <input
                              type="text"
                              value={Mensalidade}
                              onChange={t=>setMensalidade(t.target.value)}
                              maxLength={4}
                              className="border p-2 rounded"
                              placeholder="0000"
                              size={4}
                            />

                            </div> 
                    <br />
                     <div style={{ textAlign: "center",  }}>
                        <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                          <div
                            onClick={handleToggle1}
                            style={{
                              width: "60px",
                              height: "30px",
                              background: AppLimit ? "linear-gradient(90deg, #00c853, #69f0ae)" : "#ccc",
                              borderRadius: "30px",
                              position: "relative",
                              transition: "0.3s"
                            }}
                          >
                            <div
                              style={{
                                width: "26px",
                                height: "26px",
                                background: "#fff",
                                borderRadius: "50%",
                                position: "absolute",
                                top: "2px",
                                left: AppLimit ? "32px" : "2px",
                                transition: "0.3s",
                                boxShadow: "0 2px 5px rgba(0,0,0,0.3)"
                              }}
                            ></div>
                          </div>
                          <span style={{ marginLeft: "12px", fontSize: "15px", fontWeight: "bold" }}>
                            {AppLimit ? "Limite App Ativo" : "Limite App Desativado"}
                          </span>
                        </label>
                      </div>
                      {AppLimit &&
                        <>
                        
                      
                         <strong>Quantidade de App Free</strong><br />
                    <div className="input_cadatro">
                              
                              <input
                              type="text"
                              value={QuantApp}
                              onChange={t=>setQuantApp(t.target.value)}
                              maxLength={4}
                              className="border p-2 rounded"
                              placeholder="0000"
                              size={4}
                            />

                            </div> 
                    <br />
                     <strong>Valor de App</strong><br />
                    <div className="input_cadatro">
                              
                              <input
                              type="text"
                              value={ValorApp}
                              onChange={t=>setValorApp(t.target.value)}
                              maxLength={4}
                              className="border p-2 rounded"
                              placeholder="0000"
                              size={4}
                            />

                            </div> 
                    <br />
                      </>
                      }
                    </address>
                   </div>
                    <div className="col-sm-4 invoice-col">
                    <address>
                     
                    <strong>Logo da Empresa:</strong><br />
                    <div className="FotosArqui" >
                    <div className="FotoQuaAnun" >
                      {Img2 === "../assets/avatarimg.png" ?
                         <img src={Img2} alt="imagem" className="FotoQua2" />
                      :
                      <img src={Img2} alt="imagem" className="FotoQua1" />
                      }
                   
                    </div>
                  
                 
                  

                    {Imgs2 === "" ?
                     <div class="input-group">
                     <input type="file"
                     accept="image/*"
                     className="Arquivos"
                     onChange={(e)=>ColocarImg2(e)} 
                     />
                   </div>
                    :
                    <>
                    <div className="row no-print">
                   <div className="col-12">
                  <Butao 
                   style={"btn .btn-sm btn-danger"}
                   titulo={"Excluir"}
                   onClick={()=>ExcImg2()}
                   />  
                   </div>
                   </div>
                   {/* <div className="row no-print">
                   <div className="col-12">
                  <Butao 
                   style={"btn .btn-sm btn-success"}
                   titulo={"Download"}
                   onClick={()=>DownloadImg()}
                   />  
                   </div>
                   </div> */}
                  </>
                    } 

                   </div>
                      
                    
                      <strong>Toke do Mercado Pago</strong><br />
                    <div className="input_cadatro">
                              
                              <input
                              type="text"
                              value={TokenMP}
                              onChange={t=>setTokenMP(t.target.value)}
                              className="border p-2 rounded"
                              placeholder="Digite a Token"
                            />

                            </div> 
                    <br /> 
                    <strong>Key do Mercado Pago</strong><br />
                    <div className="input_cadatro">
                              
                              <input
                              type="text"
                              value={KeyMP}
                              onChange={t=>setKeyMP(t.target.value)}
                              className="border p-2 rounded"
                              placeholder="Digite a Key"
                            />

                            </div> 
                    <br /> 
                     <strong>Chave do WeebHook MP</strong><br />
                    <div className="input_cadatro">
                              
                              <input
                              type="text"
                              value={WebHookMP}
                              onChange={t=>setWebHookMP(t.target.value)}
                              className="border p-2 rounded"
                              placeholder="Digite a Chave"
                            />

                            </div> 
                    <br />
                    <div style={{ textAlign: "center",  }}>
                        <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                          <div
                            onClick={handleToggle2}
                            style={{
                              width: "60px",
                              height: "30px",
                              background: ReceberMP ? "linear-gradient(90deg, #00c853, #69f0ae)" : "#ccc",
                              borderRadius: "30px",
                              position: "relative",
                              transition: "0.3s"
                            }}
                          >
                            <div
                              style={{
                                width: "26px",
                                height: "26px",
                                background: "#fff",
                                borderRadius: "50%",
                                position: "absolute",
                                top: "2px",
                                left: ReceberMP ? "32px" : "2px",
                                transition: "0.3s",
                                boxShadow: "0 2px 5px rgba(0,0,0,0.3)"
                              }}
                            ></div>
                          </div>
                          <span style={{ marginLeft: "12px", fontSize: "15px", fontWeight: "bold" }}>
                            {ReceberMP ? "Mp Ativo" : "Mp Desativado"}
                          </span>
                        </label>
                      </div> 
                       <div style={{ textAlign: "center",  }}>
                        <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                          <div
                            onClick={handleToggle9}
                            style={{
                              width: "60px",
                              height: "30px",
                              background: WhatsAppAtiv ? "linear-gradient(90deg, #00c853, #69f0ae)" : "#ccc",
                              borderRadius: "30px",
                              position: "relative",
                              transition: "0.3s"
                            }}
                          >
                            <div
                              style={{
                                width: "26px",
                                height: "26px",
                                background: "#fff",
                                borderRadius: "50%",
                                position: "absolute",
                                top: "2px",
                                left: WhatsAppAtiv ? "32px" : "2px",
                                transition: "0.3s",
                                boxShadow: "0 2px 5px rgba(0,0,0,0.3)"
                              }}
                            ></div>
                          </div>
                          <span style={{ marginLeft: "12px", fontSize: "15px", fontWeight: "bold" }}>
                            { WhatsAppAtiv ? "Whatsapp Ativo" : "Whatsapp Desativado"}
                          </span>
                        </label>
                      </div>  
                      {WhatsAppAtiv &&
                      <>
                        <strong>Token Whatsapp</strong><br />
                    <div className="input_cadatro">
                              
                              <input
                              type="text"
                              value={TokenWhats}
                              onChange={t=>setTokenWhats(t.target.value)}
                              className="border p-2 rounded"
                              placeholder="Digite o Token"
                            />

                            </div> 
                    <br />
                        <strong>Instância Whatsapp</strong><br />
                    <div className="input_cadatro">
                              
                              <input
                              type="text"
                              value={InstanciaWhats}
                              onChange={t=>setInstanciaWhats(t.target.value)}
                              className="border p-2 rounded"
                              placeholder="Digite a Instância"
                            />

                            </div> 
                    <br />
                      </>
                      }   
                       <strong>Representante</strong><br />
                       <string>{NomeRepr}</string><br />
                    {ListRepres.length !== 0 &&
                     <div className="input_cadatro">
                        <Select
                        defaultValue={NomeRepr}
                        onChange={(target) => printValue1(target)}
                        options={ListRepres}
                        placeholder={"Escolha o Representante"}
                      /> 
                         
                     
                    </div> 
                    } <br />
                      {ListEsp.ExeciConcl === false &&
                      <>
                        <div className="col-12">
                        <Butao 
                        style={"btn .btn-sm btn-info"}
                        titulo={"Criar Exercícios"}
                        onClick={()=>CriandoExercicio()}
                        />  
                    </div><br /> 
                    <strong>{Porcen}%</strong><br />
                     </>
                      }
                    </address>
                   </div>
              </div>
              <div className="row no-print">
              </div>
              
            
            </div> 
            </div>
            </div>
            </div>
          </section>
  
</div>

            </>
        );
}